'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  _id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  thumbnail: _propTypes2.default.string,
  rank: _propTypes2.default.number,
  conditions: _propTypes2.default.shape({
    human: _propTypes2.default.bool,
    value: _propTypes2.default.string
  }),
  wind: _propTypes2.default.shape({
    speed: _propTypes2.default.number,
    direction: _propTypes2.default.number
  }),
  waveHeight: _propTypes2.default.shape({
    human: _propTypes2.default.bool,
    min: _propTypes2.default.number,
    max: _propTypes2.default.number,
    occasional: _propTypes2.default.number,
    humanRelation: _propTypes2.default.string
  }),
  tide: _propTypes2.default.shape({
    previous: _propTypes2.default.shape({
      type: _propTypes2.default.string,
      height: _propTypes2.default.number,
      timestamp: _propTypes2.default.number,
      utcOffset: _propTypes2.default.number
    }),
    next: _propTypes2.default.shape({
      type: _propTypes2.default.string,
      height: _propTypes2.default.number,
      timestamp: _propTypes2.default.number,
      utcOffset: _propTypes2.default.number
    })
  }),
  cameras: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    _id: _propTypes2.default.string,
    title: _propTypes2.default.string,
    streamUrl: _propTypes2.default.string,
    stillUrl: _propTypes2.default.string,
    rewindBaseUrl: _propTypes2.default.string,
    status: _propTypes2.default.shape({
      isDown: _propTypes2.default.bool,
      message: _propTypes2.default.string
    })
  }))
});


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/favoritePropType.js
// module id = 317
// module chunks = 0